import React, { useEffect, useState } from "react";
import {
  Layout,
  Input,
  Button,
  Select,
  message,
  Space,
  TableColumnsType,
  Form,
} from "antd";
import { toast } from "react-toastify";
import dayjs, { Dayjs } from "dayjs";
import { Modal } from "antd";
import "./index.css";
import ArchivedProjectsModal from "../ArchivedProject";
import HeaderOfList from "../../../assets/img/projectmanagerbanner.png";
import { ReactComponent as ArchiveIcon } from "../../../assets/svg/icon.svg";
import ArchivedIcon from "../../../assets/img/archivedIcon.png";
import {
  PlusOutlined,
  EyeOutlined,
  EditOutlined,
  DeleteOutlined,
  ArrowRightOutlined,
} from "@ant-design/icons";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { get, put, remove } from "../../../utils/apiUtils";
import ProjectModal from "../ProjectModal";
import { getUserRole } from "../../../hooks/getUserRoles";
import { normalizeRole, atLeast } from "../../../utils/roles";
import { useGate } from "../../Subscription/entitlements";
import DeletedProject from "../DeletedProject";
import GenericTable from "../../GeneralTable/GenericTable";
import GeneralButton from "../../GeneralButton";
import { DataType, ProjectWithCreatedAt } from "../../../types/types";
import { sortByCreatedAt } from "../../../utils/sorByCreateAt";

const { Content } = Layout;
const { Search } = Input;
const { Option } = Select;

const data: DataType[] = [
  {
    key: "1",
    projectname: "Project Alpha",
    manager: "John Doe",
    // linkedsurveys: 10,
    members: [],
    languages: ["English", "Spanish"],
    actions: <div>Actions here</div>,
  },
];

const rowSelection = {
  onChange: (selectedRowKeys: React.Key[], selectedRows: DataType[]) => {
    console.log(
      `selectedRowKeys: ${selectedRowKeys}`,
      "selectedRows: ",
      selectedRows
    );
  },
  getCheckboxProps: (record: DataType) => ({
    disabled: record.projectname === "Disabled User",
    name: record.projectname,
  }),
};

const ProjectsList = () => {
  const { t } = useTranslation("projects");
  const pageSize = 10;
  const userRole = getUserRole();
  const role = normalizeRole(userRole);
  const gate = useGate();
  const { workspaceId } = useParams<{ workspaceId: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const [selectionType, setSelectionType] = useState<"checkbox">("checkbox");
  const [searchText, setSearchText] = useState<string>("");
  const [filteredData, setFilteredData] = useState<DataType[]>(data);
  const [typeFilter, setTypeFilter] = useState<string>("Type");
  const [dateFilter, setDateFilter] = useState<Dayjs | string>("");
  const [selectedDate, setSelectedDate] = useState<Dayjs | null>(null);
  const [translationList, setTranslationList] = useState([]);
  const [translationTypes, setTranslationTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [managers, setManagers] = useState([]);
  const [countries, setCountries] = useState([]);
  const [projects, setProjects] = useState<DataType[]>([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState<any>(null);
  const [selectedManager, setSelectedManager] = useState<any>(null);
  const [search, setSearch] = useState<string>("");
  const [visible, setVisible] = useState(false);
  const [currentProjectId, setCurrentProjectId] = useState(null);
  const [modalMode, setModalMode] = useState("create");
  const [isArchivedModalVisible, setIsArchivedModalVisible] = useState(false);
  const [isDeletedModalVisible, setIsDeletedModalVisible] = useState(false);
  const [totalProjects, setTotalProjects] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);

  useEffect(() => {
    if (workspaceId) {
      localStorage.setItem("currentWorkspaceId", workspaceId);
      fetchData();
    }
  }, [workspaceId]);

  const openModalForEdit = (projectId: any) => {
    setModalMode("edit");
    setCurrentProjectId(projectId);
    setIsModalVisible(true);
  };

  const showModalForCreate = () => {
    // Prevent-at-source: block opening the create form when at the plan's
    // concurrent-project cap. The backend also enforces this (402).
    const cap = gate.plan?.concurrentProjectLimit ?? null;
    if (cap != null && totalProjects >= cap) {
      message.warning(
        t("list.planLimitWarning", { totalProjects, cap }),
      );
      return;
    }
    setModalMode("create");
    setCurrentProjectId(null);
    setIsModalVisible(true);
  };
  const viewProjectDetails = (projectId: any) => {
    setCurrentProjectId(projectId);
    setModalMode("view");
    setIsModalVisible(true);
  };

  const columns: TableColumnsType<DataType> = [
    {
      title: t("list.columns.projectName"),
      dataIndex: "projectname",
      key: "projectname",
      sorter: (a: DataType, b: DataType) =>
        a.projectname.localeCompare(b.projectname),
    },
    {
      title: t("list.columns.projectManager"),
      dataIndex: "manager",
      key: "manager",
      sorter: (a: DataType, b: DataType) => a.manager.localeCompare(b.manager),
    },
    {
      title: t("list.columns.teamMembers"),
      dataIndex: "members",
      key: "members",
      sorter: (a: DataType, b: DataType) => {
        // Convert members to strings safely
        const membersA = Array.isArray(a.members) ? a.members.join(", ") : "";
        const membersB = Array.isArray(b.members) ? b.members.join(", ") : "";
        return membersA.localeCompare(membersB);
      },
    },
    // {
    //   title: "Languages",
    //   dataIndex: "languages",
    //   key: "languages",
    //   render: (languages) => <span>{languages?.join(", ")}</span>,
    // },
    {
      //   title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space size="middle">
          <EyeOutlined
            onClick={() => viewProjectDetails(record.key)}
            style={{ fill: "#A072EB", color: "#A072EB" }}
          />
          {(atLeast(role, "manager")) && (
            <>
              <EditOutlined
                onClick={() => openModalForEdit(record.key)}
                style={{ fill: "#A072EB", color: "#A072EB" }}
              />
              <ArchiveIcon
                onClick={() => archiveProject(record.key)}
                style={{
                  color: "#A072EB",
                  width: "0.8rem",
                  height: "0.8rem",
                  marginTop: "0.4rem",
                }}
              />
              <DeleteOutlined
                onClick={() => deleteProject(record.key)}
                style={{ fill: "#A072EB", color: "#A072EB" }}
              />{" "}
            </>
          )}
          <ArrowRightOutlined
            style={{ fill: "#A072EB", color: "#A072EB" }}
            onClick={() => navigate(`/projects/${record.key}/details`)}
          />
        </Space>
      ),
    },
  ];

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await get<any>("countries/");
        console.log("countries response::", response);
        setCountries(response.data); // Assuming response data is the array of countries
      } catch (error) {
        console.error("Failed to fetch countries:", error);
        toast.error(t("list.loadCountriesFailed"));
      }
    };
    fetchCountries();
  }, []);
  useEffect(() => {
    const fetchProjectManager = async () => {
      try {
        const response = await get<any>(
          `users/project-managers?workspace_id=${workspaceId}`
        );
        if (response.type === "success") {
          setManagers(response.data);
        }
      } catch (error) {
        message.error(t("list.loadManagersFailed"));
      }
    };

    fetchProjectManager();
  }, []);
  const filterData = (): void => {
    const lowercasedSearchText = searchText.toLowerCase();
    const filtered = translationList.filter((item: any) => {
      const searchTextMatch = item.projectname
        .toLowerCase()
        .includes(lowercasedSearchText);
      const typeMatch = typeFilter === "Type" || item.type_name === typeFilter;
      const dateMatch =
        !dateFilter || dayjs(item.date).isSame(dayjs(dateFilter), "day");
      return searchTextMatch && typeMatch && dateMatch;
    });
    setFilteredData(filtered);
  };

  const deleteProject = (id: any) => {
    Modal.confirm({
      title: t("list.deleteConfirmTitle"),
      content: (
        <>
          <span style={{ textAlign: "center" }}>
            {t("list.deleteConfirmContent")}{" "}
          </span>
          <br />
          <strong>{t("list.deleteConfirmQuestion")} </strong>
        </>
      ),
      okText: t("list.deleteOk"),
      okType: "danger",
      cancelText: t("list.deleteCancel"),
      className: "delete-modal",
      onOk: async () => {
        setLoading(true);
        try {
          const token = localStorage.getItem("token");
          const res = await remove<any>(`/projects/${id}`, {});
          message.success(t("list.deleteSuccess"));
          // Refresh the list after deletion
          fetchData();
        } catch (error: any) {
          message.error(t("list.deleteError", { message: error.message }));
        } finally {
          setLoading(false);
        }
      },
    });
  };

  const archiveProject = async (id: any) => {
    try {
      const token = localStorage.getItem("token");
      let response = await put<any>(`projects/${id}/archive`, {});
      if (response.type === "success") {
        message.success(t("list.archiveSuccess"));
        fetchData();
      }
    } catch (error: any) {
      message.error(t("list.archiveError", { message: error.message }));
    }
  };

  // Utility function to validate date format
  const openArchivedProjectsModal = () => {
    setIsArchivedModalVisible(true);
  };

  const closeArchivedProjectsModal = () => {
    setIsArchivedModalVisible(false);
  };

  const openDeletedProjectsModal = () => {
    setIsDeletedModalVisible(true);
  };

  const closeDeletedProjectsModal = () => {
    setIsDeletedModalVisible(false);
  };

  const fetchData = async (
    searchTerm = "",
    managerId = "",
    countryId = "",
    skip = 0
  ) => {
    setLoading(true);
    try {
      const queryParams = new URLSearchParams();
      if (searchTerm) queryParams.append("search", searchTerm);
      if (managerId) queryParams.append("manager_id", managerId);
      if (countryId) queryParams.append("country_id", countryId);
      if (workspaceId) queryParams.append("workspace_id", workspaceId);

      queryParams.append("limit", pageSize.toString());
      queryParams.append("skip", skip.toString());

      const response = await get<any>(
        `projects/?${queryParams.toString()}`,
        {}
      );

      if (response.type === "success") {
        const projectsData: ProjectWithCreatedAt[] = response.data.items.map(
          (project: any) => ({
            key: project.id,
            projectname: project.name,
            manager: project.project_manager?.username || t("list.noManager"),
            members:
              project.team_members?.map((m: any) => m.username).join(", ") ||
              t("list.noTeamMembers"),
            created_at: project.created_at,
            actions: (
              <Space size="middle">
                <EyeOutlined onClick={() => viewProjectDetails(project.id)} />
                {(atLeast(role, "manager")) && (
                  <>
                    <EditOutlined
                      onClick={() => openModalForEdit(project.id)}
                    />
                    <DeleteOutlined onClick={() => deleteProject(project.id)} />
                  </>
                )}
                <ArrowRightOutlined
                  onClick={() => navigate(`/projects/${project.id}/details`)}
                />
              </Space>
            ),
          })
        );

        const sortedProjects = sortByCreatedAt(projectsData);

        const cleanedProjects = sortedProjects.map(
          ({ created_at, ...rest }) => rest
        );
        setProjects(cleanedProjects);
        setFilteredData(cleanedProjects);

        setTotalProjects(response.data?.total || 0);
        // setProjects(projectsData);
        // setFilteredData(projectsData);

        setTotalProjects(response.data?.total || 0);
      } else {
        toast.error(t("list.loadProjectsFailed"));
      }
    } catch (error) {
      toast.error(t("list.loadProjectsFailed"));
    } finally {
      setLoading(false);
    }
  };

  // Check if there's a projectId in location state to open the modal
  useEffect(() => {
    if (location.state && location.state.projectId) {
      openModalForEdit(location.state.projectId);
    }
  }, [location.state]);

  // useEffect(() => {
  //   fetchData(search, selectedManager, selectedCountry);
  // }, [search, selectedManager, selectedCountry]);

  useEffect(() => {
    const skip = (currentPage - 1) * pageSize;
    fetchData(search, selectedManager, selectedCountry, skip);
  }, [search, selectedManager, selectedCountry, currentPage]);

  useEffect(() => {
    setTypeFilter("Type");
    setDateFilter("");
    setSearchText("");
  }, []);

  // Initial states should be non-restrictive
  const fetchTranslationTypes = () => {
    setLoading(true);
    axios
      .get("https://aitools.kapinsights.com/translation-types", {
        headers: {
          Accept: "application/json",
        },
      })
      .then((response) => {
        setTranslationTypes(response.data);
        setLoading(false);
      })
      .catch((error) => {
        message.error(
          t("list.loadTranslationTypesFailed", { message: error.message }),
        );
        setLoading(false);
      });
  };
  useEffect(() => {
    fetchTranslationTypes();
  }, []);

  const handleDateChange = (date: Dayjs | null, dateString: string) => {
    setSelectedDate(date);
    setDateFilter(date ? date.format("YYYY-MM-DD") : "");
    filterData();
  };
  const handleModalClose = () => {
    console.log("Closing modal...");

    setIsModalVisible(false);
  };

  const handleReset = () => {
    setTypeFilter("Type");
    setDateFilter("");
    setSearchText("");
    filterData();
  };

  useEffect(() => {
    filterData();
  }, [searchText, typeFilter, dateFilter, translationList]);

  // const handleCreate = (values: any) => {
  //   setVisible(false);
  //   fetchData();
  // };

  const handleCreate = (values: any) => {
    setVisible(false);
    setIsModalVisible(false);
    setCurrentPage(1);
    fetchData(search, selectedManager, selectedCountry, 0);
  };

  const handlePagination = (page: number) => {
    const skip = (page - 1) * pageSize;
    setCurrentPage(page);
    fetchData(search, selectedManager, selectedCountry, skip);
  };

  return (
    <>
      <div className="project-layout" style={{ marginLeft: 0 }}>
        <Content className="content-styles">
          <div className="header-image">
            <img
              src={HeaderOfList}
              alt="workspaces"
              style={{ width: "100%" }}
            />
          </div>
          <Form className="survey-form-workspaces" layout="vertical">
            <div className="card" style={{ borderRadius: "8px" }}>
              <div className="title-button">
                <h2>{t("list.title")}</h2>
                {(atLeast(role, "manager")) && (
                  <div className="reset-filters-button">
                    <Button
                      className="deleted-button-style"
                      onClick={openArchivedProjectsModal}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "7px",
                      }}
                    >
                      <img
                        src={ArchivedIcon}
                        style={{
                          width: "12px",
                          height: "12px",
                        }}
                      />{" "}
                      {t("list.archivedProject")}
                    </Button>

                    <Button
                      className="deleted-button-style"
                      onClick={openDeletedProjectsModal}
                    >
                      <DeleteOutlined /> {t("list.deletedProject")}
                    </Button>

                    <GeneralButton
                      variant="default"
                      className="button-style-new-project"
                      onClick={showModalForCreate}
                    >
                      <PlusOutlined /> {t("list.newProject")}
                    </GeneralButton>
                  </div>
                )}
              </div>
              <p>{t("list.description")}</p>

              <div className="searchManagerCity-section">
                <div className="search-part">
                  <Form.Item
                    name="search"
                    label={t("list.search")}
                    className="title-filter-style"
                    style={{ marginBottom: "unset" }}
                  >
                    <Search
                      placeholder={t("list.searchPlaceholder")}
                      onSearch={(value) =>
                        fetchData(value, selectedManager, selectedCountry)
                      }
                      style={{ width: "100%" }}
                      enterButton
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </Form.Item>
                </div>
                <div className="mananger-parts">
                  <Form.Item
                    name="manager"
                    label={t("list.manager")}
                    className="title-filter-style"
                    style={{ marginBottom: "unset" }}
                  >
                    <Select
                      showSearch
                      placeholder={t("list.managerPlaceholder")}
                      style={{ width: "100%" }}
                      optionFilterProp="children"
                      filterOption={(input: any, option: any) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      onChange={(value) => {
                        setSelectedManager(value);
                        fetchData(search, value, selectedCountry);
                      }}
                      allowClear
                    >
                      {managers.map((manager: any) => (
                        <Option key={manager.id} value={manager.id}>
                          {manager.username}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
                <div className="country-part">
                  <Form.Item
                    name="country"
                    label={t("list.country")}
                    className="title-filter-style"
                    style={{ marginBottom: "unset" }}
                  >
                    {/* <Select
                      showSearch
                      placeholder="Select a country"
                      style={{ width: "100%" }}
                      optionFilterProp="children"
                      filterOption={(input: any, option: any) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      onChange={(value: any) => {
                        setSelectedCountry(value);
                        fetchData(search, value);
                      }}
                    >
                      {countries.map((country: any) => (
                        <Option key={country.id} value={country.id}>
                          {country.name}
                        </Option>
                      ))}
                    </Select> */}
                    <Select
                      // disabled
                      showSearch
                      placeholder={t("list.countryPlaceholder")}
                      style={{ width: "100%" }}
                      optionFilterProp="children"
                      filterOption={(input: any, option: any) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      onChange={(value) => {
                        setSelectedCountry(value);
                        fetchData(search, selectedManager, value);
                      }}
                      allowClear
                    >
                      {countries.map((country: any) => (
                        <Option key={country.id} value={country.id}>
                          {country.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
                {/* <div>
                  <button className="reset-all-filters-style">
                    Reset all filters
                  </button>
                </div> */}
              </div>

              {/* <Table
                rowSelection={{
                  type: selectionType,
                  ...rowSelection,
                }}
                columns={columns}
                dataSource={filteredData} 
              /> */}
              {/* <GenericTable<DataType>
                rowSelection={{
                  type: selectionType,
                  ...rowSelection,
                }}
                columns={columns}
                dataSource={filteredData}
                loading={loading}
                emptyText="No projects found"
                className="projects-table"
              /> */}
              <GenericTable<DataType>
                rowSelection={{
                  type: selectionType,
                  ...rowSelection,
                }}
                columns={columns}
                dataSource={projects}
                loading={loading}
                emptyText={t("list.emptyText")}
                className="projects-table"
                pagination={{
                  current: currentPage,
                  pageSize,
                  total: totalProjects,
                  onChange: handlePagination,
                }}
              />
            </div>
          </Form>
        </Content>

        <ProjectModal
          visible={isModalVisible}
          onCancel={handleModalClose}
          onCreate={handleCreate}
          projectId={currentProjectId}
          mode={modalMode}
        />

        <ArchivedProjectsModal
          visible={isArchivedModalVisible}
          onCancel={closeArchivedProjectsModal}
          workspaceId={workspaceId}
          onUnarchive={fetchData}
        />
        <DeletedProject
          visible={isDeletedModalVisible}
          onCancel={closeDeletedProjectsModal}
          workspaceId={workspaceId}
          restore={fetchData}
        />
      </div>
    </>
  );
};

export default ProjectsList;
